export const PIN_LENGTH = 6;
